import { Box, Typography, Paper } from '@mui/material';
import { StorageBrowser } from '@aws-amplify/ui-react-storage';
import '@aws-amplify/ui-react-storage/styles.css';

const Files = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold', mb: 4 }}>
        File Management
      </Typography>
      
      <Paper elevation={3} sx={{ p: 2, borderRadius: 2, minHeight: '70vh' }}>
        <StorageBrowser />
      </Paper>
    </Box>
  );
};

export default Files;
